<template>
  <div class="template list">
    <div class="panel_wrap">
      <label class="panel_title">申请内容：<br/>(可导入附件，建议电脑端操作)</label>
      <div class="check-list-button">
        <el-upload class="upload-demo" ref="upload" :action="link" :file-list="fileList" :on-success='uploadFileSuccess'
                   :on-error='uploadFileError' accept=".xls,.xlsx" :show-file-list="false" style="display: inline-block;margin-left: 14px;">
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        </el-upload>
      </div>
      <div class="excel-total">共计<span>{{selectArr.length}}</span>条</div>
    </div>
    <div class="choose-list" v-show="dataVal.isCheck==null||dataVal.isCheck">
      <div class="choose-list-item" v-for="(item,index) in selectArr" :key="item.assetNumber">
        <div class="delect-item" @click="delectSelectItem(index)"></div>
        <div class="panel_wrap" v-for="(data) in item" :key="data.text">
          <label class="panel_title">{{data.text}}：</label>
          <input class="input_value" :disabled="data.disabled" v-model="data.val" />
        </div>
      </div>
    </div>
    <div style="color: red;">附件导入提示：当前文件导入的总数仅支持最多200个，超过200个请再次申请</div>
    <Modal title="选项数据" v-model="dialogVisible" custom-class="check-list-dialog" :scrollable='true' class-name="check-list-dialog"
           :fullscreen='true' :closable="false" @on-ok="configSelect" @on-cancel="cancelSelecet">

      <div class="search-table">
        <label class="search-label">查询资产编号：</label>
        <div class="search-table-input">
          <Input search icon="ios-search" placeholder="查询资产编号或其他..." v-model="searchVal" @on-click="searchBtn" />
        </div>
      </div>
      <!-- @on-selection-change="selectChange" -->
      <Table ref="selection" stripe border size="small" :columns="dataVal.listTitle" :data="dataVal.listData" no-data-text="该表暂无数据"
             @on-select-all="selectAll" @on-select-all-cancel="selectCancelAll"  @on-select="select" @on-select-cancel="selectCancel"></Table>


      <div class="pages-fixed">
        <Page :current="current" @on-change="changePages" :total="dataVal.TotalCount" :page-size="pageSize" simple />
      </div>
    </Modal>


  </div>
</template>

<script>
import {
  Message
} from 'element-ui'
export default {
  props: ['dataVal'],
  data() {
    return {
      dialogVisible: false,
      selectArr: [],
      selectionArr: [],
      searchVal: '',
      fileList: [],
      current: 1,
      total: 50,
      pageSize: 10,
      link: '/api/filemanage/analysis-scrap-excel'
    }
  },
  mounted() {
    if(this.dataVal.isCheck!=null&&!this.dataVal.isCheck){
      this.link+="?isCheck=false";
    }
  },
  computed:{
    listenerListData() {
      return this.dataVal.listData
    }
  },
  watch:{
    listenerListData:function(val,oldVal){
      if(val != oldVal){
        for (var i = 0, len = this.dataVal.listData.length; i < len; i++) {
          let noId = this.dataVal.listData[i].AssetsCode
          for (var j = 0, length = this.selectionArr.length; j < length; j++) {
            var id = this.selectionArr[j].AssetsCode;
            if (id == noId) {
              this.dataVal.listData[i]._checked = true
            }
          }
        }
      }
    }
  },
  methods: {
    checkList() {
      //_checked: true
      for (var i = 0, len = this.dataVal.listData.length; i < len; i++) {
        let noId = this.dataVal.listData[i].AssetsCode
        for (var j = 0, length = this.selectionArr.length; j < length; j++) {
          var id = this.selectionArr[j].AssetsCode;
          if (id == noId) {
            this.dataVal.listData[i]._checked = true;
            continue;
          }
        }
      }
      this.dialogVisible = true;
    },
    selectAll(selection) {
      // this.selectionArr = selection;
      let arr = [],val;
      for (val in this.selectionArr) {
        if(arr.indexOf(this.selectionArr[val].AssetsCode) < 0){
          arr.push(this.selectionArr[val].AssetsCode)
        }
      }

      for(var i=0,len = selection.length;i<len;i++){
        if(arr.indexOf(selection[i].AssetsCode)<0){
          this.selectionArr.push(selection[i])
        }
      }
    },
    selectCancelAll(selection){
      let arr = [],val;
      for (val in this.selectionArr) {
        arr.push(this.selectionArr[val].AssetsCode)
      }
      for (var i = 0,len = this.dataVal.listData.length;i<len;i++) {
        var index = arr.indexOf(this.dataVal.listData[i].AssetsCode)
        if(index >= 0){
          this.selectionArr.splice(index,1);
          arr.splice(index,1)
        }
        index = null;
      }
      arr = null;val = null;
    },
    selectChange(selection) {
      // this.selectionArr = selection;
      let arr = [],val;

      for (val in this.selectionArr) {
        if(arr.indexOf(this.selectionArr[val].AssetsCode) < 0){
          arr.push(this.selectionArr[val].AssetsCode)
        }
      }

      selection.forEach((item,index)=>{
        if(arr.indexOf(item.AssetsCode) < 0){
          this.selectionArr.push(item);
          arr.push(item.AssetsCode);
        }else{
          this.selectionArr.splice(index,1);
          arr.splice(arr.indexOf(item.AssetsCode),1);
        }
      })
    },
    select(selection,row){
      this.selectionArr.push(row);
    },
    selectCancel(selection,row){
      for(var i = 0,len = this.selectionArr.length;i<len;i++){
        if(row.AssetsCode == this.selectionArr[i].AssetsCode){
          this.selectionArr.splice(i,1);
          break;
        }
      }
    },
    configSelect() {
      this.dialogVisible = false;
      var selectDatas = [];
      for (var i = 0; i < this.selectionArr.length; i++) {
        var dataArr = Object.entries(this.selectionArr[i]);
        var selectData = [];
        for (var k = 0; k < this.dataVal.listTitle.length; k++) {
          for (var j = 0; j < dataArr.length; j++) {
            if (this.dataVal.listTitle[k].key == dataArr[j][0]) {
              selectData.push({
                'text': this.dataVal.listTitle[k].title,
                "val": dataArr[j][1],
                "disabled": this.dataVal.listTitle[k].disabled
              });
            }
          }

        }
        selectDatas.push(selectData)
      }
      this.selectArr = selectDatas;
      this.$emit('child-event', this.selectArr,"changeData");
      this.dataVal.listData.forEach((item, index) => {
        item._checked = false;
      })
      // this.selectionArr = [];
    },
    cancelSelecet() {
      this.dialogVisible = false;
      this.selectionArr = [];
      this.selectArr = [];
      this.$emit('child-event', this.selectArr,"changeData");
      this.$refs.selection.selectAll(false);

    },
    delectSelectItem(index) {
      let id = '';
      for(var v = 0,length = this.selectArr[index].length;v<length;v++){
        if(this.selectArr[index][v].text == '资产编号'){
          id = this.selectArr[index][v].val;
          break
        }
      }

      for (var i = 0, len = this.dataVal.listData.length; i < len; i++) {
        if (this.dataVal.listData[i].AssetsCode == id) {
          this.dataVal.listData[i]._checked = false;
          break
        }
      }
      this.selectArr.splice(index, 1);
      this.selectionArr.splice(index, 1);
      this.$emit('child-event', this.selectArr,"changeData");
      this.$emit('child-event', this.current,"changePages");
    },
    searchBtn() {
      this.$emit('child-event', this.searchVal,"search");
    },
    // 上传成功
    uploadFileSuccess(response, file, fileList) {
      var selectDatas = [];
      if(response.Body==null||response.Body.length<=0){
        Message({
          message: response.ErrMsg,
          type: 'error',
          duration: 3 * 1000
        });
        return;
      }
      for (var i = 0; i < response.Body.length; i++) {
        var dataArr = response.Body[i];
        var selectData = [];
        for (var j = 0; j < dataArr.length; j++) {
          selectData.push({
            'text': this.dataVal.listTitle[j + 1].title,
            "val": dataArr[j],
            "disabled": this.dataVal.listTitle[j + 1].disabled
          });
        }
        selectDatas.push(selectData)
      }
      this.selectArr = selectDatas;
      this.$emit('save-event', file.raw,"save");
      this.$emit('child-event', this.selectArr,"changeData");
    },
    // 上传失败
    uploadFileError(response, file, fileList) {
    },
    // 点击上一页或者下一页或者跳转页数的操作
    changePages(page) {
      this.current = page;
      this.$emit('child-event', page,"changePages");
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/common.css";

.check-list-button {
  display: inline-block;
  color: #868C98;
  padding-left: 10px;
  text-align: right;
  flex: 1;
  box-shadow: none;
  border: none;
  background: #fff;
}

.choose-list-item {
  position: relative;
  border-bottom: 1px solid #EEEEEE;

  .panel_wrap {
    padding: 5px 8px 5px 15px;
  }

  .delect-item {
    position: absolute;
    width: 26px;
    height: 26px;
    top: 0;
    left: 0;
    background: url(../assets/image/icons.png);
    background-position: -633px 0;
    transform: rotate(270deg);
    z-index: 99;
  }
}

.choose-list-item:first-child {
  border-top: 1px solid #EEEEEE;
}

.search-table {
  padding: 10px;
  overflow: hidden;
  width: 100%;
  height: 52px;
  position: relative;
  font-size: 13px;

  .search-label {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    position: relative;
    // top: -10px;
  }

  .search-table-input {
    display: inline-block;

    .ivu-input {
      font-size: 13px !important;
    }
  }
}

.pages-fixed {
  height: 38px;
  line-height: 38px;
  text-align: right;
  padding: 0 10px;
}

.excel-total{
  position: absolute;
  font-size: 12px;
  bottom: 2px;
  right: 15px;
  span{
    color: #FF0000;
  }
}
</style>
